import { createContext } from "react";

const RemittanceContext = createContext();

export default RemittanceContext;
